<template>
  <div class="faqPage">
    <TopBack :title="$t('lang.menu.FAQ')" style='margin-top: 66px;'/>
    <div class="faqList" v-if="!showDetail">
      <div class="row" v-for="(item, index) in faqList" :key="index" @click="goto(item)">
        <div class="question">{{item.label}}</div>
        <div class="more">···</div>
      </div>
    </div>
    <FAQdetail :detail="detail" v-if="showDetail"/>
  </div>
</template>

<script>
import TopBack from '@/components/TopBack/index'
import FAQdetail from './children/FAQdetail'
export default {
  name: 'FAQ',
  data () {
    return {
      faqList: this.$t('lang.faqList'),
      detail: this.$t('lang.faqList')[0],
      key: 'common',
      showDetail: false
    }
  },
  watch: {
    '$store.state.locale': function () {
      this.faqList = this.$t('lang.faqList')
      this.detail = this.$t('lang.faqList')[0]
    }
  },
  components: {
    TopBack,
    FAQdetail
  },
  methods: {
    goto (item) {
      let userInfo = localStorage.getItem('userInfo')
      if (item.key === 'workOrderReview') {
        if (userInfo) {
          this.$router.push('workOrderReview')
        } else {
          this.$router.push('login')
        }
      } else {
        this.detail = item
        this.showDetail = true
      }
    },
    close () {
      this.showDetail = false
    }
  }
}
</script>

<style lang="less" scoped>
  .faqPage {
    position: relative;
    height: 80dvh;
    .faqList {
      padding: 32px 16px 0;
      .row {
        display: flex;
        justify-content: space-between;
        padding-bottom: 16px;
        color: #F6D9AA;
        border-bottom: 1px solid #70614A;
        margin-bottom: 30px;
        text-transform: capitalize;
        &:nth-child(even) {
          .question {
            color: #BA9251;
          }
        }
        &:last-child {
          margin-bottom: 0;
        }
        .question, .more {
          font-size: 18px;
          line-height: 21px;
        }
        .more {
          font-size: 30px;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/FAQ/index.vue